'use strict';

/**
 * @author Maxim Seredkin
 */

import angular from 'angular';

export default [function() {
    return {
        restrict: 'A',
        template: require('../view/okved-node.html'),
        controller: ['$scope', '$element',
                     function($scope, $element) {
                         $scope.isOpen = has($scope.selectedItem, $scope.item);

                         function has(selectedItem, item) {
                             if (item == null) {
                                 return false;
                             }
                             if (angular.equals(item, selectedItem)) {
                                 setTimeout(() => {
                                    if ($element && $element[0] && $element[0].children[0]) {
                                        if ($element[0].children[0].scrollIntoViewIfNeeded) {
                                            $element[0].children[0].scrollIntoViewIfNeeded();
                                        } else {
                                            $element[0].children[0].scrollIntoView();
                                        }
                                    }
                                }, 0);
                                 return true;
                             }
                             let eq = false;
                             for (let i = 0; item.nodes != null && i < item.nodes.length; ++i) {
                                 eq = eq || has(selectedItem, item.nodes[i]);
                             }
                             return eq;
                         }

                         $scope.$on('updateStateNode', function(event, _data) {
                             $scope.isOpen = has($scope.selectedItem, $scope.item);
                         });
                     }],
    };
}];
